// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__2IZBo","logoLink":"styles_logoLink__2zwQU","logo":"styles_logo__23AeS"};